var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicationSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3984_1371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4855 0.0815506C11.6266 0.197214 10.7542 0.598183 10.0238 1.21891C9.64847 1.53506 2.13152 10.1135 1.88468 10.5067C1.48229 11.1429 1.2253 11.7713 1.05961 12.527C0.772184 13.8186 0.88039 15.1834 1.3707 16.3786C2.41218 18.9348 4.87049 20.2765 7.25779 19.5902C7.91717 19.4013 8.46834 19.1083 9.02628 18.6495C9.37119 18.368 16.8949 9.79733 17.1722 9.36937C17.6084 8.70238 17.8654 8.08165 18.0412 7.29128C18.3286 5.99969 18.2204 4.63486 17.7301 3.43966C16.7935 1.13795 14.6936 -0.203754 12.4855 0.0815506ZM13.9632 1.95916C15.2549 2.36399 16.2085 3.46665 16.5365 4.93559C16.6311 5.3674 16.6244 6.45464 16.5229 6.87103C16.4147 7.32598 16.2626 7.70767 16.036 8.10478C15.8602 8.40936 15.5728 8.75635 14.0849 10.4605L12.3435 12.4576L9.83106 9.59299L7.31865 6.72838L8.83354 5.00113C9.66537 4.04883 10.4871 3.12351 10.6629 2.94616C11.1938 2.39869 11.7179 2.08254 12.357 1.92446C12.7425 1.82808 13.6048 1.84735 13.9632 1.95916ZM6.37185 8.36695C6.48682 8.45948 6.55445 8.66382 6.52063 8.81419C6.50373 8.8913 6.08105 9.40407 5.17144 10.4489C4.12319 11.6595 3.81548 12.0335 3.69037 12.2648C3.42323 12.7545 3.31841 13.1207 3.26431 13.753C3.22035 14.2388 3.12229 14.3815 2.83486 14.3815C2.74018 14.3815 2.68608 14.3506 2.59478 14.2465L2.47305 14.1077L2.49334 13.6759C2.52377 12.955 2.69961 12.3497 3.0648 11.7135C3.23725 11.4205 3.49763 11.1005 4.50868 9.93227C5.18835 9.14961 5.80715 8.45948 5.87816 8.40165C6.04047 8.26671 6.22983 8.25129 6.37185 8.36695Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3984_1371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.313,
    height: 19.74,
    fill: "white",
    transform: "translate(0.893555 0.0390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicationSvg);
export default __webpack_public_path__ + "static/media/MedicationSvg.71f71d07cf7e51e74534373404330d7f.svg";
export { ForwardRef as ReactComponent };